import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Oni donacis al mi superban rozon. 
      Ĝi estis diafana kaj trembrilis kaj glimis per miloj da lumoj: ruĝaj, verdaj, violaj. 
      Ravita pro ĝia beleco, mi tenere ĉirkaŭpolmis ĝin kaj kaŝis ĉe la sino, proksime al la koro.
    </p>
    
    <p class="mb-3">
      Sed baldaŭ mi ekhavis tre strangan impreson, kvazaŭ io frida tuŝas mian bruston, kaj poste eksentis, ke malvarmaj fluoj kuras laŭ la korpo. 
      Kun miro mi gapis – kaj trovis nur grandan malsekan makulon, kiu tiel malagrable incitis la haŭton. 
    </p>

    <p class="mb-3">
      La rozo estis el glacio.
    </p>
    `
  )
}

const itemName = {
  esp: 'La bela rozo'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemVideo: ['R89-74LGpRc'],
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;